import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSearchIconSecondary from './svgs/SearchIconSecondary.js';
import SvgSearchIcon from './svgs/SearchIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var searchIcon = (props => useIcon(SvgSearchIcon, SvgSearchIconSecondary, props));

export { searchIcon as default };
